import actions from '@/core/store/pedido/documentos/actions'
import mutations from '@/core/store/pedido/documentos/mutations'
import state from '@/core/store/pedido/documentos/state'
import documentoEditorTexto from '@/core/store/pedido/documentos/documento/editor-texto'
import documentoAnexo from '@/core/store/pedido/documentos/anexo'
import processoDigitalPedido from '@/core/store/pedido/documentos/processo-digital'
import signatariosPedido from '@/core/store/pedido/documentos/signatarios'

export default {
	actions,
	mutations,
	state,
	modules: {
		documentoEditorTexto,
		documentoAnexo,
		processoDigitalPedido,
		signatariosPedido,
	},
}
